import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import VoucherController from "../controllers/VoucherController";
import { TProductVoucher } from "../types/Voucher";

export interface IProductVouchersProps {
  productId: string;
}

export const useProductVouchers = ({ productId }: IProductVouchersProps) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<TProductVoucher[]>([]);
  const [error, setError] = React.useState<string>("");

  const execute = async () => {
    if (!loading) {
      try {
        setLoading(true);

        if (error !== "") {
          setError("");
        }

        const response = await VoucherController.getProductVouchers({
          productId,
        });
        const responseError = response as IErrorResponse;
        const responseData = response as TProductVoucher[];

        if (responseError.code) {
          setError(responseError.error);
          setData([]);
        } else {
          setData(responseData);
        }
      } catch (e) {
        var message = "Erro não identificado";
        if (typeof e === "string") {
          message = e.toUpperCase();
        } else if (e instanceof Error) {
          const err = e as Error;
          message = err.message;
        }
        setError(message);
      } finally {
        setLoading(false);
      }
    }
  };

  React.useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  const clear = () => {
    setError("");
  };

  return {
    loading,
    data,
    error,
    execute,
    clear,
  };
};
